module.exports = "<block-ui> <router-outlet></router-outlet> </block-ui>\r\n"